
<template>
    <div class="flex contact-table-actions">
        <button class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out"
            @click.stop="$emit('event', 'edit')"
        >
            <font-awesome-icon :icon="['far', 'pen-to-square']"></font-awesome-icon><span class="sr-only">Edit</span>
        </button>
        <button class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-red-400 transition duration-150 ease-in-out"
                @click.stop="$emit('event', 'delete')"
        >
            <font-awesome-icon :icon="['far', 'trash-can']"></font-awesome-icon><span class="sr-only">Delete</span>
        </button>
    </div>
</template>

<script>
import JetDropdown from "../Jetstream/Dropdown";
import JetDropdownLink from "../Jetstream/DropdownLink";

export default {
    name: "ContactTableButton",
    components: {JetDropdown, JetDropdownLink,},
    emits: ['event', 'button-click'],
    data() {
        return {
            eventType: ''
        }
    },
    methods: {
        handleClickEvent(type) {
            this.eventType = type;
            this.$emit('button-click', {
                type: this.eventType,
                data: this.data
            });
        }
    },
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => {}
        },
        click: {
            type: Function,
            default: () => {}
        }
    }
}
</script>

<style scoped>
    .contact-table-actions {
        max-width: 40px;
    }
</style>
